import { render, staticRenderFns } from "./historicalSensorManagement.vue?vue&type=template&id=a338aaa4&scoped=true"
import script from "./historicalSensorManagement.vue?vue&type=script&lang=js"
export * from "./historicalSensorManagement.vue?vue&type=script&lang=js"
import style0 from "./historicalSensorManagement.vue?vue&type=style&index=0&id=a338aaa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a338aaa4",
  null
  
)

export default component.exports